export function Loader({ label = "Un momento…" }) {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-4 bg-[#09090B]" data-testid="loader">
      <div className="h-9 w-9 animate-spin rounded-full border-2 border-[#27272A] border-t-[#D4AF37]" />
      <p className="text-base text-[#B4B4BC]">{label}</p>
    </div>
  );
}
